const React = require('react');
const T = require('prop-types');
const { default: Styled } = require('styled-components');

const internals = {};

module.exports = function AppPage(props) {

    const {
        title,
        children
    } = props;

    const { Wrapper } = internals;

    return (
        <Wrapper>
            {title && <h2>{title}</h2>}
            {children}
        </Wrapper>
    );
};

module.exports.propTypes = {
    title: T.string,
    children: T.any
};

internals.Wrapper = Styled.div`
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    padding: 24px;

    h2 {
        font-size: 28px;
        margin-top: 14px;
        margin-bottom: 24px;
    }

    @media (max-width: 600px) {
        padding: 16px;
    }
`;
